"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cfeDefinicion = void 0;
exports.cfeDefinicion = {
    101: {
        codigo: 101,
        nombre: "e-Ticket",
        nombreXml: "eTck"
    },
    102: {
        codigo: 102,
        nombre: "e-Ticket Nota de Crédito",
        nombreXml: "eTck"
    },
    103: {
        codigo: 103,
        nombre: "e-Ticket Nota de Débito",
        nombreXml: "eTck"
    },
    111: {
        codigo: 111,
        nombre: "e-Factura",
        nombreXml: "eFact"
    },
    112: {
        codigo: 112,
        nombre: "e-Factura Nota de Crédito",
        nombreXml: "eFact"
    },
    113: {
        codigo: 113,
        nombre: "e-Factura Nota de Débito",
        nombreXml: "eFact"
    },
    121: {
        codigo: 121,
        nombre: "e-Factura de Exportación",
        nombreXml: "eFact"
    },
    122: {
        codigo: 122,
        nombre: "e-Factura de Exportación Nota de Crédito",
        nombreXml: "eFact"
    },
    123: {
        codigo: 123,
        nombre: "e-Factura de Exportación Nota de Débito",
        nombreXml: "eFact"
    },
    124: {
        codigo: 124,
        nombre: "e-Remito de Exportación",
        nombreXml: "eRem_Exp"
    },
    131: {
        codigo: 131,
        nombre: "e-Ticket Cuenta Ajena",
        nombreXml: "eTck"
    },
    132: {
        codigo: 132,
        nombre: "e-Ticket Cuenta Ajena Nota de Crédito",
        nombreXml: "eTck"
    },
    133: {
        codigo: 133,
        nombre: "e-Ticket Cuenta Ajena Nota de Débito",
        nombreXml: "eTck"
    },
    141: {
        codigo: 141,
        nombre: "e-Factura Cuenta Ajena",
        nombreXml: "eFact"
    },
    142: {
        codigo: 142,
        nombre: "e-Factura Cuenta Ajena Nota de Crédito",
        nombreXml: "eFact"
    },
    143: {
        codigo: 143,
        nombre: "e-Factura Cuenta Ajena Nota de Débito",
        nombreXml: "eFact"
    },
    151: {
        codigo: 151,
        nombre: "e-Boleta",
        nombreXml: "eBoleta"
    },
    152: {
        codigo: 152,
        nombre: "e-Boleta Nota de Crédito",
        nombreXml: "eBoleta"
    },
    153: {
        codigo: 153,
        nombre: "e-Boleta Nota de Débito",
        nombreXml: "eBoleta"
    },
    181: {
        codigo: 181,
        nombre: "e-Remito",
        nombreXml: "eRem"
    },
    182: {
        codigo: 182,
        nombre: "e-Resguardo",
        nombreXml: "eResg"
    },
    201: {
        codigo: 201,
        nombre: "e-Ticket de Contigencia",
        nombreXml: "eTck"
    },
    202: {
        codigo: 202,
        nombre: "e-Ticket Nota de Crédito de Contigencia",
        nombreXml: "eTck"
    },
    203: {
        codigo: 203,
        nombre: "e-Ticket Nota de Débito de Contigencia",
        nombreXml: "eTck"
    },
    211: {
        codigo: 211,
        nombre: "e-Factura de Contigencia",
        nombreXml: "eFact"
    },
    212: {
        codigo: 212,
        nombre: "e-Factura Nota de Crédito de Contigencia",
        nombreXml: "eFact"
    },
    213: {
        codigo: 213,
        nombre: "e-Factura Nota de Débito de Contigencia",
        nombreXml: "eFact"
    },
    221: {
        codigo: 221,
        nombre: "e-Factura de Exportación de Contigencia",
        nombreXml: "eFact"
    },
    222: {
        codigo: 222,
        nombre: "e-Factura de Exportación Nota de Crédito de Contigencia",
        nombreXml: "eFact"
    },
    223: {
        codigo: 223,
        nombre: "e-Factura de Exportación Nota de Débito de Contigencia",
        nombreXml: "eFact"
    },
    224: {
        codigo: 224,
        nombre: "e-Remito de Exportación de Contigencia",
        nombreXml: "eRem"
    },
    231: {
        codigo: 231,
        nombre: "e-Ticket Cuenta Ajena de Contigencia",
        nombreXml: "eTck"
    },
    232: {
        codigo: 232,
        nombre: "e-Ticket Cuenta Ajena Nota de Crédito de Contigencia",
        nombreXml: "eTck"
    },
    233: {
        codigo: 233,
        nombre: "e-Ticket Cuenta Ajena Nota de Débito de Contigencia",
        nombreXml: "eTck"
    },
    241: {
        codigo: 241,
        nombre: "e-Factura Cuenta Ajena de Contigencia",
        nombreXml: "eFact"
    },
    242: {
        codigo: 242,
        nombre: "e-Factura Cuenta Ajena Nota de Crédito de Contigencia",
        nombreXml: "eFact"
    },
    243: {
        codigo: 243,
        nombre: "e-Factura Cuenta Ajena Nota de Débito de Contigencia",
        nombreXml: "eFact"
    },
    251: {
        codigo: 251,
        nombre: "e-Boleta de Contigencia",
        nombreXml: "eBoleta"
    },
    252: {
        codigo: 252,
        nombre: "e-Boleta Nota de Crédito de Contigencia",
        nombreXml: "eBoleta"
    },
    253: {
        codigo: 253,
        nombre: "e-Boleta Nota de Débito de Contigencia",
        nombreXml: "eBoleta"
    },
    281: {
        codigo: 281,
        nombre: "e-Remito de Contigencia",
        nombreXml: "eRem"
    },
    282: {
        codigo: 282,
        nombre: "e-Resguardo de Contigencia",
        nombreXml: "eResg"
    }
};
